import React from "react";
import { ReadingAssessmentSvg } from "./ela-icon";
import { MathAssessmentSvg } from "./math-icon";
import { ISubjectIconProps } from "../../growbot/icons";

export function SubjectIcon({ subject, color }: ISubjectIconProps) {
  const size = 58;
  if (subject.toLowerCase() === "math") {
    return <MathAssessmentSvg color={color} size={size} />;
  }
  return <ReadingAssessmentSvg color={color} size={size} />;
}
